<h1 mat-dialog-title>Nieuwe omgeving aanmaken</h1>
<div mat-dialog-content class="dialog-no-overflow">
  <form [formGroup]="newOrgForm" autocomplete="off">
    <mat-form-field>
      <mat-label>Naam</mat-label>
      <input formControlName="organisationName" matInput required />
      @if (newOrgForm.controls.organisationName.errors?.required) {
        <mat-error>Vul dit veld in.</mat-error>
      }
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>

  <button mat-flat-button (click)="create()">Aanmaken</button>
</div>
